// extracted by mini-css-extract-plugin
export default {"ToggleButton":"style_ToggleButton__YiVnV","ActiveBtn":"style_ActiveBtn__9WnhQ","InactiveBtn":"style_InactiveBtn__u41dm"};